import { Component, OnInit } from '@angular/core';
import { SeguridadService } from '../../services/seguridad.service';
import { Usuario } from '../../model/usuario';
import { Permisos } from '../../model/permisos';

import { LocalStorageService } from 'angular-2-local-storage';


@Component({
  selector: 'app-menu-principal',
  templateUrl: './menu-principal.component.html',
  styleUrls: ['./menu-principal.component.css']
})
export class MenuPrincipalComponent implements OnInit {


  public usuario: Usuario = new Usuario();
  public permisos: Permisos[];

  public mantenimientos: Permisos[];
  public procesos: Permisos[];
  public reportes: Permisos[];



  constructor
    (private _localStorageService: LocalStorageService,
    private _seguridadService: SeguridadService) { }


  ngOnInit() {

    this.mantenimientos = [];
    this.procesos = [];
    this.reportes = [];


    if (sessionStorage.getItem("login") === null) {
      var div = document.getElementById("Menu_Nav");
      if (div) {
        div.style.display = "none";
      }
    } else {

      if (sessionStorage.getItem("menu") != null) {
        this.generarMenus(JSON.parse(sessionStorage.getItem("menu")));
      } else {
        this.usuario.email = sessionStorage.getItem("login");
        this._seguridadService.getPermisos(this.usuario).subscribe(
          data => {
            this.permisos = data;
            sessionStorage.setItem("menu", JSON.stringify(data));
            this.generarMenus(data);
          },
          err => {
            console.clear();
            console.log(err._body);
          });
      }

    }

  }

 Salir_Sistema(){
    sessionStorage.removeItem("login");   
    sessionStorage.removeItem("menu");   
 }

  generarMenus(permisos: Permisos[]) {

    this.mantenimientos = [];
    this.procesos = [];
    this.reportes = [];

    for (var i = 0; i < permisos.length; i++) {
      if (permisos[i].CODIGOCATEGORIA === "MANTENIMIENTO") {
        this.mantenimientos.push(permisos[i]);

      }

      if (permisos[i].CODIGOCATEGORIA === "PROCESOS") {
        this.procesos.push(permisos[i]);

      }

      if (permisos[i].CODIGOCATEGORIA === "REPORTES") {
        this.reportes.push(permisos[i]);

      }


    }

  }



  OrdenarPermisos(arr) {
    var Menu = {};
    for (var i = 0; i < arr.length; i++) {
      if (!Menu.hasOwnProperty(arr[i].CODIGOCATEGORIA)) {
        Menu[arr[i].CODIGOCATEGORIA] = [];
      }
      Menu[arr[i].CODIGOCATEGORIA].push(arr[i]);
    }
    return Menu;
  };

  CrearMenu(obj) {
    var Menu = document.getElementById("Menu_Tags");
    var textoHTML = "";
    var num = 0;
    for (var key in obj) {
      num++;
      textoHTML = textoHTML + this.CrearCategorias(key, obj[key], num);
    }
    Menu.innerHTML = Menu.innerHTML.toUpperCase() + textoHTML.toUpperCase();
  };


  CrearCategorias(cat, arr, num) {
    var textoHTML = "";
    var textoLI = '<li class="nav-item dropdown item-menu-drop">@CONTENIDO<li>';
    var textoA = '<a class="nav-link dropdown-toggle" id="dropdown0@NUM" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">@TEXTO</a>';
    textoA = textoA.replace("@NUM", num);
    textoA = textoA.replace("@TEXTO", cat);
    textoHTML = textoHTML + textoA;
    var textoDIV = '<div class="dropdown-menu" aria-labelledby="dropdown0@NUM">@CONTENIDO</div>';
    textoDIV = textoDIV.replace("@NUM", num);
    var textoLINKS = "";
    for (var i = 0; i < arr.length; i++) {
      var textoLINK = '<a class="dropdown-item" [routerLink]="[@RUTA]">@TEXTO</a>';
      textoLINK = textoLINK.replace("@TEXTO", arr[i].NOMBREPERMISO);
      textoLINK = textoLINK.replace("@RUTA", "'" + arr[i].RUTA + "'");
      textoLINKS = textoLINKS + textoLINK;
    }
    textoDIV = textoDIV.replace("@CONTENIDO", textoLINKS);
    textoHTML = textoHTML + textoDIV;
    textoLI = textoLI.replace("@CONTENIDO", textoHTML);
    return textoLI;
  };

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/menu-principal/menu-principal.component.ts